export interface SearchProps {
  value?: string | null
  'data-qa'?: string
  onSearch: (text: string) => void
  placeholder?: string
}
